class Accordion extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const accordionHeaders = this.querySelectorAll(".accordion__header");
    const openFirstItem = this.getAttribute("data-open-first") === "true";

    if (openFirstItem === true) {
      const firstItem = this.querySelector(".accordion__item");

      if (firstItem) this.openFirstItem(firstItem);
    }

    accordionHeaders.forEach(el => el.addEventListener("click", this.accordionClickEvent));

    this.openFooterAccordion();
  }

  openFirstItem(el) {
    !el.classList.contains("accordion__item--open") ? Accordion.openAccordion(el, true) : null;
  }

  accordionClickEvent() {
    const accordionItem = this.closest(".accordion__item");
    const accordionContainer = this.closest("accordion-wrapper");
    const mobileOnly = accordionContainer.getAttribute("data-mobile-only") === "true";
    const touchOnly = accordionContainer.getAttribute("data-touch-only") === "true";

    const mediaQuery = window.matchMedia("(max-width: 989px)");

    if (mobileOnly || touchOnly) {
      if (mediaQuery.matches) Accordion.toggleStates(accordionContainer, accordionItem);
    } else {
      Accordion.toggleStates(accordionContainer, accordionItem);
    }
  }

  // Toggle active states of clicked accordion
  static toggleStates(container, item) {
    const wrapper = container.closest(".js-accordion-container");
    const parent = container.parentNode;
    const accordionItems = (wrapper || parent).querySelectorAll(".accordion__item");
    const autoClose = container.getAttribute("data-auto-close") === "true";

    if (!item.classList.contains("accordion__item--open")) {
      if (autoClose === true) {
        accordionItems.forEach(el =>
          el.classList.contains("accordion__item--open")
            ? this.closeAccordion(el)
            : null
        );
      }

      // Duration of animation
      setTimeout(() => this.openAccordion(item), 250);
    } else {
      this.closeAccordion(item);
    }
  }

  static openAccordion(el, openFirst) {
    el.classList.add("accordion__item--open");

    const content = el.querySelector(".accordion__content");
    const width = getComputedStyle(content).width;

    // Set properties to calculate height whilst hiding element
    content.style.width = width;
    content.style.position = 'absolute';
    content.style.visibility = 'hidden';
    content.style.height = 'auto';

    const height = getComputedStyle(content).height;

    // Reset properties used above to calculate height
    content.style.width = null;
    content.style.position = null;
    content.style.visibility = null;
    content.style.height = "0";

    // Force repaint
    getComputedStyle(content).height;
    requestAnimationFrame(() => {
      content.style.height = height
      if (!openFirst) Accordion.repositionViewport(el);
    });

    content.addEventListener("transitionend", () => {
      if (el.classList.contains("accordion__item--open")) content.style.height = "auto";
    });
  }

  static repositionViewport(el) {
    const offset = document.documentElement.scrollTop;
    const target = el.getBoundingClientRect().top;

    const rootStyles = getComputedStyle(document.documentElement);
    let headerVar = rootStyles.getPropertyValue("--header-height").trim();
    if (!headerVar) headerVar = rootStyles.getPropertyValue("--mobile-header-height").trim();
    const headerHeight = parseFloat(headerVar) || 0;

    let stickyNavHeight = 0;
    const stickyNavEl = document.querySelector(".sticky-navigation");
    if (stickyNavEl) {
      stickyNavHeight = stickyNavEl.getBoundingClientRect().height || 0;
    }

    const y = target + offset - headerHeight - stickyNavHeight;

    requestAnimationFrame(() => window.scrollTo({ top: y, behavior: "smooth" }));
  }

  static closeAccordion(el) {
    el.classList.remove("accordion__item--open");

    const content = el.querySelector(".accordion__content");

    content.style.height = getComputedStyle(content).height;

    // Force repaint
    getComputedStyle(content).height;

    requestAnimationFrame(() => content.style.height = "0");
  }

  openFooterAccordion() {
    const accordion = document.querySelector(".footer__newsletter .accordion__item");
    const url = window.location.href;


    if (url.includes("#ContactFooter")) Accordion.openAccordion(accordion);
  }
}

customElements.define("accordion-wrapper", Accordion);
